<template lang="html">
  <div class="dib relative user-select-none">
    <v-btn @click.native="toggleDropdown()"
      :label="labelText"
      icon-code="keyboard_arrow_down"
      icon-pos="right"
      icon-class="f5 b mt1"
      class="bg-transparent b f6 hover-action font-futura"
    />
    <dropdown-container :open="open" @cancel="cancelDropdown">
      <div
        v-for="(option, index) in options"
        :key="'option-' + index"
        @click="toggleDropdown(index)"
        class="pointer hover-bg-highlight ph4 pv3 nowrap
        bb bg-white b--moon-gray
        br2-ns bn-ns pv1-ns ph2-ns
        flex items-center"
        :class="{ 'bt': index === 0 }"
      >
        <span>{{ option }}</span>
        <i v-if="index === selectedIndex" class="ml2 f6 b material-icons">check</i>
      </div>
    </dropdown-container>
  </div>
</template>

<script>
import DropdownContainerComponent from '@/components/DropdownContainer';
import ButtonComponent from '@/components/Button';

export default {
  components: {
    'dropdown-container': DropdownContainerComponent,
    'v-btn': ButtonComponent
  },
  props: {
    stickyLabel: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: 'select'
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    selectedIndex: {
      type: Number,
      default: -1
    },
    onChange: {
      type: Function,
      default(mutableSelectedIndex) {
        this.$emit('change', mutableSelectedIndex);
      }
    }
  },
  data() {
    return {
      open: false,
      mutableSelectedIndex: -1
    };
  },
  computed: {
    labelText() {
      if (this.stickyLabel || this.mutableSelectedIndex === -1) return this.label;
      return this.mutableSelectedIndex;
    }
  },
  methods: {
    toggleDropdown(index) {
      this.mutableSelectedIndex = index;
      if (this.open) {
        this.open = false;
        this.onChange(this.mutableSelectedIndex);
      } else {
        this.open = true;
      }
    },
    cancelDropdown() {
      this.open = false;
      this.mutableSelectedIndex = this.selectedIndex;
    }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/SingleSelect.vue